import React from 'react';
import { Label } from 'reactstrap';
import { useFormContext, get, Controller  } from "react-hook-form";
import './Formgroup.css'
import Tooltip from './Tooltip';
import { CurrencyInput, Currencies, Locales  } from "input-currency-react";

type NumberFieldProps = {
    name: string;
    label?: string;
    currency?: boolean;
    className?: string;
    defaultValue?: number;
    maxLength?: number;
    disabled?: boolean;
    required?: boolean;
    min?: number;
    max?: number;
    tooltipBody?: () => JSX.Element;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function NumberField({ className, label, currency, name, defaultValue, maxLength, disabled, min, max, tooltipBody, required }: NumberFieldProps) {
    const { register, formState: { errors }, control } = useFormContext();
    const error = get(errors, name);

    const validations = {
        required,
        min,
        max
    };

    const handleCurrency = (value: string, field: any) => {
        if (value) {
            field.onChange(value == "£0.00" ? undefined : value);
        }
    }

    return (
        <>
            {label && <Label htmlFor={name}>{label}</Label>}
            {tooltipBody &&
                <Tooltip tooltipBody={tooltipBody()} />
            }
            {currency ?
            <Controller
                control={control}
                name={name}
                rules={validations}
                shouldUnregister={true}
                render={({ field }) => (
                <CurrencyInput
                    id={name + "-currency-input"}
                    className={className ? `form-control ${className}` : 'form-control'}
                    onChangeEvent={(_, maskedValue) => handleCurrency(maskedValue, field)}
                    value={field.value}
                    defaultValue={defaultValue}
                    name={name}
                    disabled={disabled}
                    required={true}
                    options={{
                        style: "currency",
                        allowNegative: false,
                        locale: Locales["English (United Kingdom)"],
                        i18nCurrency: Currencies["Pound Sterling"]
                    }}
                />
                )}
            /> :
            <input {...register(name, validations)}
                className={className ? `form-control  ${className}` : 'form-control'}
                type="number"
                defaultValue={defaultValue}
                maxLength={maxLength}
                name={name}
                disabled={disabled}
                min={min ? min : 0}
                max={max ? max : 0}
            />
            }
            <div className="form-error-wrapper">
                {error?.type === 'required' && 'This is a required field'}
            </div>
        </>    
    );
}
export default NumberField;
